
import React from 'react'
import BulkUploadAWB from '../../components/AWBDashboard/BulkUploadAWB';
import { set, setSeconds } from 'date-fns';

const BulkUploadCSV = () => {
  const [showAirBulk, setShowAirBulk] = React.useState(false);
  return (
    <div><BulkUploadAWB setShowAirBulk={setShowAirBulk}/></div>
  )
}

export default BulkUploadCSV;
